'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMasonryComponent = require('react-masonry-component');

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var masonryOptions = {
	transitionDuration: 0,
	gutter: '.gutter'
};

var Images = function (_Component) {
	_inherits(Images, _Component);

	function Images() {
		_classCallCheck(this, Images);

		return _possibleConstructorReturn(this, (Images.__proto__ || Object.getPrototypeOf(Images)).apply(this, arguments));
	}

	_createClass(Images, [{
		key: 'render',
		value: function render() {
			var _props$data = this.props.data,
			    images = _props$data.images,
			    title = _props$data.title;

			return _react2.default.createElement(
				'div',
				{ className: 'images-container' },
				_react2.default.createElement(
					'h2',
					null,
					title
				),
				_react2.default.createElement(
					_reactMasonryComponent2.default,
					{
						className: 'images',
						options: masonryOptions,
						ref: function (c) {
							this.masonry = this.masonry || c.masonry;
						}.bind(this)
					},
					images.map(function (image, i) {

						return _react2.default.createElement(
							'div',
							{ className: 'image', key: i },
							_react2.default.createElement('img', { src: image.sizes.logo.url, alt: '' }),
							_react2.default.createElement(
								'div',
								{ className: 'caption' },
								image.caption
							)
						);
					}),
					_react2.default.createElement('div', { className: 'gutter' })
				)
			);
		}
	}]);

	return Images;
}(_react.Component);

exports.default = Images;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/Images.js
// module id = 578
// module chunks = 0